import { connect } from 'react-redux';

import { sendVideoReminder } from 'api/events/events.actions';
import { SendReminderButton } from './SendReminderButton';
import { SendVideoReminderBody } from 'api/events/events.types';

const mapDispatchToProps = (dispatch: Function) => ({
  sendVideoReminder: (eventId: string, body: SendVideoReminderBody) => dispatch(sendVideoReminder(eventId, body)),
});

export const SendReminderButtonContainer = connect(null, mapDispatchToProps)(SendReminderButton);
